import userApi from "../../services/user.api";
import { DisabledUser } from "@/types/disabled-user.definition";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  fetchDisabledUsersFailure,
  fetchDisabledUsersRequest,
  fetchDisabledUsersSuccess,
  reactivateUserFailure,
  reactivateUserRequest,
  reactivateUserSuccess,
} from "../reducers/disabledUsersSlice";

function* fetchDisabledUsersSaga() {
  try {
    const users: DisabledUser[] = yield call(userApi.getDisabledUsers);
    yield put(fetchDisabledUsersSuccess(users));
  } catch (error) {
    yield put(
      fetchDisabledUsersFailure(
        error instanceof Error
          ? error.message
          : "Failed to fetch disabled users"
      )
    );
  }
}

function* reactivateUserSaga(action: {
  payload: { userId: number };
  type: string;
}) {
  try {
    yield call(userApi.reactivateUser, action.payload.userId);
    yield put(reactivateUserSuccess(action.payload.userId));
  } catch (error) {
    yield put(
      reactivateUserFailure(
        error instanceof Error ? error.message : "Failed to reactivate user"
      )
    );
  }
}

export function* disabledUsersSaga() {
  yield takeLatest(fetchDisabledUsersRequest, fetchDisabledUsersSaga);
  yield takeEvery(reactivateUserRequest, reactivateUserSaga);
}
